module.exports = {"description":"","displayName":"PageHeader","methods":[],"props":{"children":{"type":{"name":"node"},"required":false,"description":"PageHeader content"},"cssMap":{"defaultValue":{"value":"require( './pageHeader.css' )","computed":true},"required":false}}}


//////////////////
// WEBPACK FOOTER
// ./.lochness/props/PageHeader-props.json
// module id = 454
// module chunks = 0